import InputBase from '@material-ui/core/InputBase/InputBase';
import FormControl from '@material-ui/core/FormControl';
import { makeStyles } from '@material-ui/core/styles';

import NotesIcon from '../../../assets/icons/NotesIcon';

const useStyles = makeStyles((theme) => ({
  textareaContainer: {
    width: '100%',
    outline: 'none',
  },
  textarea: {
    width: '100%',
    outline: 'none',
    lineHeight: '1.5rem',
  },
}));

const DispatchNote = ({ value, onChange, title = '' }) => {
  const classes = useStyles();

  return (
    <div className='dispatch-modal__note-container'>
      <div className='d-flex'>
        <NotesIcon />
        <div className='m-l-md font-bold'>{title}</div>
      </div>

      <div className='m-t-lg'>
        <FormControl className={classes.textareaContainer}>
          <InputBase
            multiline
            rows={4}
            id='dispatch-note'
            type='text'
            className={classes.textarea}
            value={value}
            placeholder='Type or paste any dispatch notes to be added to the export here'
            onChange={(e) => onChange(e.target.value)}
          />
        </FormControl>
      </div>
    </div>
  );
};

export default DispatchNote;
